import React from 'react'
import { useTranslation } from 'react-i18next'
import StandardLayout from './StandardLayout'

import { ChildProps } from '~/common/define/props'
import PublicHeader from '~/components/molecules/header/public/PublicHeader'
import { loginPath, signupPath } from '~/common/define/path'
import DeviceView, { Device } from '~/components/wrapper/view/DeviceView'
import SupportButton from '~/components/atoms/button/SupportButton'
import CopyRightFooter from '~/components/atoms/footer/CopyRightFooter'
import ModalActionButton from '~/components/atoms/button/ModalActionButton'
import ExtraSection from '~/components/wrapper/section/ExtraSection'
import FormCenterArea from '~/components/wrapper/form/FormCenterArea'
import FormSide from '~/components/wrapper/form/FormSide'

interface Props extends ChildProps {
  isResponsive?: boolean
}

const LoginableLayout = ({children, isResponsive}: Props) => {
  const {t} = useTranslation('contact')
  return (
    <StandardLayout isResponsive>
      <PublicHeader>
        <FormSide>
          <ModalActionButton link={signupPath()}>
            {t('contact:free')}
          </ModalActionButton>
          <DeviceView hide={Device.SP}>
            <SupportButton  link={loginPath()}>
              {t('contact:login')}
            </SupportButton>
          </DeviceView>
        </FormSide>
      </PublicHeader>
      {children}
      {isResponsive &&
        <DeviceView hide={Device.PC}>
          <ExtraSection>
            現在VISLITEはPCのみでご利用いただけます。<br/>
            ご利用の際にはPCにてご利用くださいませ。
          </ExtraSection>
        </DeviceView>
      }
      <CopyRightFooter />
    </StandardLayout>
  )
}

export default LoginableLayout